module.exports = __webpack_public_path__ + "img/extra-link-icon.62d376a.svg";